<template>
    <section class="section m-t-20">
        <b-loading :active.sync="loading" :is-full-screen="false"></b-loading>

       <div v-for="sec in sections" :key="sec.id">
            <Section
            v-if="sec.products.length"
            :section="sec"/>
       </div>

    </section>
</template>

<script>
import { getHandler } from '../../../services/http'
import Section from "./components/Section.vue"
export default {
    components:{
        Section
    },
    props:{
        sectionsEndpoint:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            sections:[],
            loading:false,
            model:0
        }
    },
    methods:{
        async fetchSections(){
            this.loading = true
            this.sections = await getHandler(this.sectionsEndpoint, {error:false, success:false})
            this.loading = false
            console.log(this.sections)
        }
    },
    created(){
        this.fetchSections()
    }

}
</script>